module.exports = __webpack_public_path__ + "img/deviceCode.fe33fde8.png";